import { orgAPI } from "@/api/api";
import { IntegrationConnection } from "@cohesive/api-client";
import { GithubProjectEntity } from "@cohesive/api-entities";
import { useQuery } from "@tanstack/react-query";

interface UseGitHubProjectsListParams {
  connection: IntegrationConnection;
  owner: string;
  ownerType: "user" | "organization";
}

export function useGitHubProjectsList({
  connection,
  owner,
  ownerType,
}: UseGitHubProjectsListParams) {
  return useQuery({
    queryKey: ["github-projects-list", connection?.id || "", owner],
    queryFn: () => {
      return orgAPI.toolbox.execute<GithubProjectEntity[]>({
        integration_connection_id: connection?.id || "",
        action_name: "github-projects-list",
        action_input: {
          owner,
          owner_type: ownerType,
          first: 50,
        },
        // Typed projects drive the rich row UI; their generic projections ride
        // along in data_generic and are what get placed on the canvas.
        entity_format: "both",
      });
    },
    enabled: !!connection?.id,
    staleTime: 1000 * 60 * 5,
  });
}
